<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/dealerships">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Exportar excel CCS</h2>
        <p class="page-subtitle">Exporte os dados das concessionárias em formato Excel</p>
      </div>
    </div>

    <div class="form-section">
      <form [formGroup]="formExport" class="flex flex-col gap-5 w-full">
        <app-select-form-field
          label="Montadora (OE)"
          class="w-2on6"
          [control]="automaker"
          [options]="automakers"
          [display]="companyDisplayName"
        />
        <div class="flex flex-row">
          <mat-form-field class="w-2on6">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
              <mat-option value="AF">Ativas</mat-option>
              <mat-option value="IF">Inativas</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/dealerships">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
